













import Vue, { PropType } from 'vue'
import { HeaderDropdown } from '~/models/header/header-dropdown'
import EventBuilder from '~/builders/event/EventBuilder'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'

export default Vue.extend({
  components: {
    LinkDropdownContent: () =>
      import('~/components/car/header/LinkDropdown/LinkDropdownContent.vue')
  },
  props: {
    dropdown: {
      type: Object as PropType<HeaderDropdown>,
      required: true
    }
  },
  data: (): { shown: boolean } => ({ shown: false }),
  computed: {
    icons: () => ({ angleDown: ciAngleDownLight })
  },
  mounted() {
    const dropdownElement = this.$refs.dropdown as Element
    this.$dep(EventBuilder)
      .hover(dropdownElement)
      .setComponent(this)
      .onNextTick()
      .onEnter(() => {
        this.shown = true
      })
      .onLeave(() => {
        this.shown = false
      })
      .build()
  }
})
